import axios from 'axios';

import { ApiResponse } from '../api-helpers';
import { API_BASE_URL } from '../config/constants';

/**
 * Müşteri API yardımcı fonksiyonları
 * Bu dosya, müşteri işlemleri için gerekli API çağrılarını içerir.
 */

// Müşteri adres bilgilerini eklemek için API çağrısı
export const addCustomerAddress = async (
  token: string,
  customerCode: string,
  addressData: any
): Promise<ApiResponse<any>> => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/v1/Customer/${customerCode}/addresses`,
      addressData,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );
    
    return response.data;
  } catch (error: any) {
    console.error('API: Add customer address error:', error);
    
    return {
      success: false,
      message: `Adres eklenirken hata oluştu: ${error.response?.data?.message || error.message}`,
      data: null
    };
  }
};

// Müşteri iletişim bilgilerini eklemek için API çağrısı
export const addCustomerCommunication = async (
  token: string,
  customerCode: string,
  communicationData: any
): Promise<ApiResponse<any>> => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/v1/Customer/${customerCode}/communications`,
      communicationData,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );
    
    return response.data;
  } catch (error: any) {
    console.error('API: Add customer communication error:', error);
    
    return {
      success: false,
      message: `İletişim bilgisi eklenirken hata oluştu: ${error.response?.data?.message || error.message}`,
      data: null
    };
  }
};

// Müşteri kişi bilgilerini eklemek için API çağrısı
export const addCustomerContact = async (
  token: string,
  customerCode: string,
  contactData: any
): Promise<ApiResponse<any>> => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/v1/Customer/${customerCode}/contacts`,
      contactData,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );
    
    return response.data;
  } catch (error: any) {
    console.error('API: Add customer contact error:', error);
    
    return {
      success: false,
      message: `Kişi bilgisi eklenirken hata oluştu: ${error.response?.data?.message || error.message}`,
      data: null
    };
  }
};
